export let navigate = null;

export const setGlobalNavigate = (nav) => {
  navigate = nav;
};
